import ProductoCreate from './ProductoCreate'
export {ProductoCreate}
export default ProductoCreate
